import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'groupmonthreport',
  templateUrl: './groupmonthreport.component.html',
  styleUrls: ['./groupmonthreport.component.css']
})
export class GroupMonthReportComponent implements OnInit {

  periodType:string = "month";
  spinnerMessage: string = 'Please wait, report data is fetched';
  constructor() { }

  ngOnInit() {
  }

}